// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2LpXl","col":"styles_col__2l0FG","fulfillmentStatus":"styles_fulfillmentStatus__3JQnz","emailCol":"styles_emailCol__1pmSq"};